import _typeof from "@babel/runtime/helpers/typeof";
import a from "../../../helpers/AxiosURLSearchParams.js";
var e = (typeof URLSearchParams === "undefined" ? "undefined" : _typeof(URLSearchParams)) < "u" ? URLSearchParams : a;
export { e as default };
